export default "__VITE_ASSET__CIdURv4f__"